<template>
    <div class="vx-container vx-mx-auto vx-px-3 vx-pb-32 md:vx-px-8 vx-font-sans vx-max-w-screen-xl">
        <h1 class="vx-sr-only">Dashboard</h1>

        <div class="vx-grid vx-grid-cols-12 vx-gap-x-6 vx-gap-y-8">
            <div class="vx-col-span-12 md:vx-col-span-8 lg:vx-col-span-8 vx-grid vx-items-stretch">
                <home-call-to-action></home-call-to-action>
            </div>
            <div class="vx-col-span-12 md:vx-col-span-4 lg:vx-col-span-4">
                <vx-box color="white"
                    class="vx-col-span-1 vx-h-full">
                    <h2 class="vx-px-6 vx-pt-6 vx-pb-3 vx-mb-0 vx-font-extrabold vx-text-slate-8000 vx-text-base">
                        Getting Started
                    </h2>
                    <vx-list>
                        <vx-list-item v-if="['admin', 'marketer'].includes(roleOnCurrentGroup)" href="/contacts/segments/new">
                            <vx-list-icon class="vx-bg-slate-100">
                                <font-awesome-icon :icon="faScreenUsers" />
                            </vx-list-icon>
                            Create a Segment
                        </vx-list-item>
                        <vx-list-item href="/messaging/snippets">
                            <vx-list-icon class="vx-bg-slate-100">
                                <font-awesome-icon :icon="faPlus" />
                            </vx-list-icon>
                            Create a Snippet
                        </vx-list-item>
                        <vx-list-item v-if="!groupsUseCorporateNumbers" href="/messaging/messagehub">
                            <vx-list-icon class="vx-bg-slate-100">
                                <font-awesome-icon :icon="faMessage" />
                            </vx-list-icon>
                            Send a Message
                        </vx-list-item>

                        <vx-list-item href="https://support.voxie.com/hc/en-us"
                            target="_blank"
                            rel="noopener noreferrer">
                            <vx-list-icon class="vx-bg-slate-200">
                                <font-awesome-icon :icon="faStar" />
                            </vx-list-icon>
                            Browse our Documentation
                        </vx-list-item>
                    </vx-list>
                </vx-box>
            </div>

            <div class="vx-col-span-12 vx-flex vx-flex-col vx-gap-6 lg:vx-grid lg:vx-grid-cols-2">
                <vx-box color="info"
                    class="vx-px-6 vx-pt-6 vx-pb-3 vx-flex vx-flex-col vx-gap-6">
                    <div>
                        <h2 class="vx-font-extrabold vx-text-slate-8000 vx-text-base">
                            Browse Snippets
                        </h2>
                        <div class="vx-text-slate-500 vx-text-sm">
                            See messages shared by corporate or create your own for quick, consistent sending.
                        </div>
                    </div>
                    <img class="vx-rounded-xl vx-w-full vx-block vx-object-cover vx-object-center vx-aspect-[536/196]"
                        :src="homeGroupSnippetsUrl"
                        alt="Browse Snippets">
                    <vx-button href="/messaging/snippets"
                        block
                        size="lg">
                        Snippets <font-awesome-icon :icon="faSquareArrowUpRight"></font-awesome-icon>
                    </vx-button>
                </vx-box>
                <vx-box v-if="['admin', 'marketer', 'blast'].includes(roleOnCurrentGroup)" color="info"
                    class="vx-px-6 vx-pt-6 vx-pb-3 vx-flex vx-flex-col vx-gap-6">
                    <div>
                        <h2 class="vx-font-extrabold vx-text-slate-8000 vx-text-base">
                            Send a Campaign
                        </h2>
                        <div class="vx-text-slate-500 vx-text-sm">
                            The fastest way to send a single message to multiple people.
                        </div>
                    </div>
                    <img class="vx-rounded-xl vx-mt-auto vx-w-full vx-block vx-object-cover vx-object-center vx-aspect-[536/196]"
                        :src="homeGroupQuickBlastUrl"
                        alt="Browse Snippets">
                    <vx-button href="/messaging/quick-blast"
                        block
                        size="lg">
                        Quick Blast <font-awesome-icon :icon="faSquareArrowUpRight"></font-awesome-icon>
                    </vx-button>
                </vx-box>
            </div>
        </div>
    </div>
</template>

<script setup>
import homeGroupQuickBlastUrl from '@img/home-group-quick-blast.jpg';
import homeGroupSnippetsUrl from '@img/home-group-snippets.jpg';
import HomeCallToAction from './HomeCallToAction.vue';
import {
    faMessage,
    faPlus,
    faScreenUsers,
    faSquareArrowUpRight,
    faStar,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
    VxBox,
    VxButton,
    VxList,
    VxListIcon,
    VxListItem,
} from "@voxie/frontend-components";
import { useCurrentGroup } from '~/composables/useCurrentGroup';

const groupsUseCorporateNumbers = Spark.state.currentTeam.groups_use_corporate_numbers;
const { roleOnCurrentGroup } = useCurrentGroup();
</script>
